import ChipsLayout from '@components/shared/ChipsLayout';
import DarkLayout from '@components/shared/DarkLayout';
import HireForm from '@components/shared/forms/HireForm';

const successMetric = [
  {
    title: 'Completed 1000+ hours of Coding.',
    icon: '/assets/images/almax/trophy-front-gradient@3x.png',
  },
  {
    title: 'Completed 50+ Mock Interviews',
    icon: '/assets/images/almax/sheild-front-gradient@3x.png',
  },
  {
    title: 'Completed 5+ Industry projects',
    icon: '/assets/images/almax/lab-front-gradient@3x.png',
  },
  // {
  //   title: '3000+ AlmaBetter Graduates',
  //   icon: '/assets/images/almax/chat-bubble-dynamic-gradient 1@3x.png',
  // },
];

const successChips = [
  {
    point: 'ZERO',
    subject: 'Hiring fee for recruiters',
  },
  {
    point: '<1 Week',
    subject: 'Quick turn around time',
  },
  {
    point: 'Top 1%',
    subject: 'Trained by IIT & IIM graduates',
  },
  {
    point: '3000+',
    subject: 'Students placed',
  },
];

const Hero = () => {
  return (
    <DarkLayout customStyle="md:grid-cols-12 px-[16px] md:px-[106px] pt-[24px] pb-[50px] items-center gap-[64px]">
      <div className="relative z-10 flex flex-col gap-y-[24px] md:col-span-6">
        <div className="flex flex-col gap-y-[12px] text-white">
          <h1 className="font-satoshi-bold text-[36px] leading-[44px] md:text-left md:text-[48px] md:leading-tight">
            Start hiring the top 1%
            <br /> <span className="text-red">Tech Talent</span>
          </h1>
          <p className="font-satoshi-medium text-[20px] leading-[30px]">
            Build your Data & Engineering Team with industry ready 3000+ top skilled tech talent.
          </p>
        </div>

        <ChipsLayout
          customStyle="md:col-span-12"
          chipStyle="flex flex-col items-center gap-y-[8px] px-[4px]"
          subjectStyle="text-[16px] leading-6 md:text-[18px] font-satoshi-medium md:leading-7 text-[#8D8D8D] text-center"
          pointStyle="text-[24px] leading-9 md:text-[28px] md:leading-none text-white text-center"
          darkMode
          chipsData={successChips}
          isMobile={true}
        />
      </div>
      <div className="flex justify-center md:col-span-6">
        <div className="md:w-4/5" id="hireForm">
          <HireForm />
        </div>
      </div>
    </DarkLayout>
  );
};

export default Hero;

// const Hero = ({ hero: { heading, description, buttonText } }) => (
//   <div className="flex flex-col items-center justify-center mx-auto mt-5 mb-20 md:justify-between lg:flex-row lg:items-center">
//     <div className="flex flex-col items-center justify-center mx-auto text-left lg:justify-evenly">
//       {heading && (
//         <h1 className="text-center text-[2.6rem]">
//           {heading}
//           <span className="relative inline-block text-red">
//             Zero Hiring Cost
//             <span className="absolute -bottom-2 right-0 left-0 h-1 bg-gradient-to-r  from-[#2D23A6] to-[#E10E5A]"></span>
//           </span>
//         </h1>
//       )}
//       {description && (
//         <p className="text-para mt-8 text-center text-xl font-black lg:w-3/4 lg:text-[22px]">
//           {description}
//         </p>
//       )}

//       <section className="relative my-8 flex w-[20rem] overflow-hidden md:w-[28rem]">
//         <div
//           style={{
//             background: 'rgb(255,255,255)',
//             background:
//               'linear-gradient(90deg, rgba(255,255,255,1) 41%, rgba(255,255,255,0.2721682422969187) 89%)',
//           }}
//           className="absolute top-0 left-0 z-10 w-8 h-full"
//         ></div>
//         <div
//           style={{
//             background: 'rgb(255,255,255)',
//             background:
//               'linear-gradient(90deg,rgba(255,255,255,0.2721682422969187) 12%, rgba(255,255,255,1)  41%)',
//           }}
//           className="absolute top-0 right-0 z-10 w-8 h-full"
//         ></div>

//         {Array(2)
//           .fill('')
//           .map((i, index) => (
//             // eslint-disable-next-line react/jsx-key
//             <div className="flex items-center animate-infiniteScroll">
//               {[
//                 'data-engineering',
//                 'data analyst',
//                 'full stack developer',
//                 'software engineer',
//                 'data scientist',
//               ].map((name) => (
//                 // eslint-disable-next-line react/jsx-key
//                 <p className="mx-1.5 whitespace-nowrap text-sm font-satoshi-bold font-bold  capitalize">
//                   {name} <span className="mx-1.5 text-gray-dark">|</span>
//                 </p>
//               ))}
//             </div>
//           ))}
//       </section>

//       {buttonText && (
//         <a
//           href="#hire-form"
//           className="py-2 text-center text-white rounded-sm fint-semibold text-md w-52 bg-red lg:text-lg"
//         >
//           <div>{buttonText}</div>
//         </a>
//       )}
//     </div>
//   </div>
// );

// export default Hero;
